import React, { useState } from "react";
import Graph from "./graph";
import Download from "./download";
import Server from "./server";
import Settings from "./settings";
import Loading from "./loading";
import TrashCan from "./trashCan";
import Document from "./document";
import ZipFile from "./zipFile";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import Clipboard2 from "./clipboard2";
import moment from "moment-timezone";
import fetchWithPreSigned from "./fetchWithPreSigned";
import formatTimeRead from "./formatTimeRead";

const NavInfoSubmissions = (props) => {
    const [requestLifeCycle, setRequestLifeCycle] = useState(false);
    const [requestLifeCycleTwo, setRequestLifeCycleTwo] = useState(false);
    const { courseCode, assessmentCode } = useParams()
    const location = useLocation();
    const navigate = useNavigate();
    const currentPath = location.pathname;

    const handleGetSubmissionInformation = async () => {
        const url = process.env.REACT_APP_SUBMISSION_API_URL + `/get-assessment-grades/${courseCode}/${assessmentCode}?tz=${moment.tz.guess()}`;
    
        try {
            setRequestLifeCycle(true)
            const response = await fetch(url, {
                method: "GET",
                credentials: "include"
            });
            
            if (response.status === 401) {
                window.location.href = process.env.REACT_APP_401_REDIRECT_URL;
            }
    
            const blob = await response.blob(); // Convert response to a Blob
            const urlBlob = URL.createObjectURL(blob); // Create a URL for the Blob
    
            // Create a link element
            const a = document.createElement('a');
            a.href = urlBlob;
            const formatted = formatTimeRead();
            a.download = props.name.toLowerCase().replace(/ /g, '-') + `-grades-${formatted}.csv`; // Name of the downloaded file
    
            // Append the link to the body
            document.body.appendChild(a);
            a.click(); // Programmatically click the link to trigger the download
    
            // Clean up
            document.body.removeChild(a);
            URL.revokeObjectURL(urlBlob); // Revoke the Blob URL
            setRequestLifeCycle(false)
        } catch (error) {
            console.error('Failed to fetch the CSV file:', error);
        } finally {
            setRequestLifeCycle(false)
        }
    }

    const aggregateLogs = async () => {
        try {
            setRequestLifeCycleTwo(true);
            const url = process.env.REACT_APP_SUBMISSION_API_URL + `/aggregate-logs/${courseCode}/${assessmentCode}`
            const urlOptions = {
                method: "POST",
                credentials: "include"
            }

            const response = await fetch(url, urlOptions);
            const data = await response.json();

            if (response.status === 200) {
                const [code, blob] = await fetchWithPreSigned(data.url);

                if (code === 200) {
                    const urlBlob = URL.createObjectURL(blob);
    
                    // Create a link element
                    const a = document.createElement('a');
                    a.href = urlBlob;
                    const formatted = formatTimeRead();
                    a.download = props.name.toLowerCase().replace(/ /g, '-') + `-logs-${formatted}.zip`;
            
                    // Append the link to the body
                    document.body.appendChild(a);
                    a.click();
            
                    // Clean up
                    document.body.removeChild(a);
                    URL.revokeObjectURL(urlBlob);
                } else  {
                    alert("An error occurred while fetching the file with status code: " + code);
                }

            } else if (response.status === 401) {
                window.location.href = process.env.REACT_APP_401_REDIRECT_URL;
            } else if (response.status === 409) {
                alert(data.detail);
            } else {
                alert("Status Code: " + response.status + " Error: " + data.detail);
            }

        } catch(error) {
            alert("Error: " + error.message);
            console.log(error);
        } finally {
            setRequestLifeCycleTwo(false);
        }
    };

    const handleDocumentClick = async (event) => {
        try {
            const url = process.env.REACT_APP_SUBMISSION_API_URL + `/get-next-submission/${courseCode}/${assessmentCode}/na`;
            const urlOptions = {
                method: "GET",
                credentials: "include"
            }
            
            const response = await fetch(url, urlOptions);
            const data = await response.json();
            if (response.status === 200) {
                if (event.metaKey || event.ctrlKey) {
                    // Open in a new tab
                    window.open(`/${courseCode}/${assessmentCode}/${data.email}`, '_blank');
                } else {
                    // Navigate in the same tab
                    navigate(`/${courseCode}/${assessmentCode}/${data.email}`);
                }
            } else if (response.status === 401) {
                window.location.href = process.env.REACT_APP_401_REDIRECT_URL;
            }


        } catch (error) {
            console.log(error);
        }
    }

    const handleEditClick = (event) => {
        if (event.metaKey || event.ctrlKey) {
            // Open in a new tab
            window.open(`/${courseCode}/${assessmentCode}/edit`, '_blank');
        } else {
            // Navigate in the same tab
            navigate(`/${courseCode}/${assessmentCode}/edit`)
        }
    }

    return (
        <>
            <div className="semester-nav-info">
                <div className="side-nav-info-header">
                    { props.name }
                </div>
                <div className={`open-nav ${!currentPath.endsWith("/statistics") && !currentPath.endsWith("/settings") && !currentPath.includes("@") && !currentPath.endsWith("/edit") ? "current" : "hover"}`} style={{ cursor: "pointer" }} onClick={ props.handleDashboardClick }>
                    <Server /> Dashboard
                </div>
                <div className={`open-nav ${currentPath.endsWith("/edit") ? "current" : "hover"}`} style={{ cursor: "pointer" }} onClick={ handleEditClick }>
                    <Clipboard2 /> Edit Eval
                </div>
                <div className={`open-nav ${currentPath.endsWith("/settings") ? "current" : "hover"}`} style={{ cursor: "pointer" }} onClick={ props.handleDetailsClick }>
                    <Settings /> Settings
                </div>
                <div className={`open-nav ${currentPath.includes("@") ? "current" : "hover"}`} style={{ cursor: "pointer" }} onClick={ handleDocumentClick }>
                    <Document /> Grade Submission
                </div>
                <div className={`open-nav ${currentPath.endsWith("/statistics") ? "current" : "hover"}`} style={{ cursor: "pointer" }} onClick={ props.handleStatisticsClick }>
                    <Graph /> Statistics
                </div>
                <div className="side-nav-info-header">
                    Actions
                </div>
                <div className="instructor-name underline" style={{ cursor: "pointer", width: "100%" }} onClick={handleGetSubmissionInformation}>
                    <Download /> 
                    { 
                        requestLifeCycle

                        ?

                        <div className="loading-container" style={{ maxWidth: "110px" }}>
                            <Loading />
                        </div>

                        :

                        <div className="loading-container" style={{ justifyContent: "flex-start" }}>
                            Download Grades
                        </div>

                    }
                </div>
                {
                    props.showAggregation && (
                        <div className="instructor-name underline" style={{ cursor: "pointer", width: "100%" }} onClick={aggregateLogs}>
                            <div className="icon-3" style={{ border: "none", borderRadius: "0px" }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0M9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1m-1 4v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 11.293V7.5a.5.5 0 0 1 1 0"/>
                                </svg>
                            </div>
                            { 
                                requestLifeCycleTwo

                                ?

                                <div className="loading-container" style={{ maxWidth: "110px" }}>
                                    <Loading />
                                </div>

                                :

                                <div className="loading-container" style={{ justifyContent: "flex-start" }}>
                                    Aggregate All Logs
                                </div>

                            }
                        </div>
                    )
                }                
                <div className="instructor-name underline" style={{ cursor: "pointer" }} onClick={ () => { props.updateDeleteEvaluation(true) } }>
                    <TrashCan /> Delete Evaluation
                </div>
            </div>
        </>
    );
}

export default NavInfoSubmissions;